import { render, staticRenderFns } from "./MaterialOnlyOneMouht.vue?vue&type=template&id=1162e91b&scoped=true&"
import script from "./MaterialOnlyOneMouht.vue?vue&type=script&lang=ts&"
export * from "./MaterialOnlyOneMouht.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialOnlyOneMouht.vue?vue&type=style&index=0&id=1162e91b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162e91b",
  null
  
)

export default component.exports